import React, { useState, useEffect } from 'react';
import { sendSelectedAdsAccounts } from '../../../../services/marketPlaceConnection';

const AmazoneAdsCartView = ({ authData, onDone }) => {
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [disableBtn, setDisableBtn] = useState(false);
  const needMarketplaceAccount = JSON.parse(localStorage.getItem("need_marketplace_account"));


  useEffect(() => {
    if (!needMarketplaceAccount) {
      // Wait until next tick to ensure DOM is ready
      const timer = setTimeout(() => {
        const main = document.getElementById('main');
        const header = document.querySelector('.header');

        if (main) main.style.marginLeft = '0';
        if (header) header.style.marginLeft = '0';
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [needMarketplaceAccount]);

  const toggleSelect = (account) => {
    setSelectedAccounts((prev) => {
      const exists = prev.some((a) => a?.external_id === account?.external_id);
      return exists
        ? prev.filter((a) => a?.external_id !== account?.external_id)
        : [...prev, account];
    });
  };

  const handleBulkConnect = async () => {
    setDisableBtn(true);
    try {
      const response = await sendSelectedAdsAccounts({ accounts: selectedAccounts });
      if (response.success) {
        setDisableBtn(false);
        const needSubscription = await response?.data?.some(account => account?.need_subscription === true);
        await onDone(selectedAccounts, needSubscription);
      } else {
        console.error('Amazon auth process failed', response);
      }
    } catch (error) {
      setDisableBtn(false);
      console.error(`Amazon connect failed:`, error);
    }
  };

  return (
    <div className="select-market-place-container">
      <div
        className="row d-flex justify-content-center align-items-center min-vh-100 px-3"
        style={{ paddingTop: "50px" }}
      >
        <div className="col-12 col-lg-10">
          <div className="select-market-place-card py-4">
            <div className=" mb-5">
              <h5 className="modal-title fw-bold text-center w-100 display-6">Select Your Amazon Advertising Profile</h5>
              <p className='text-center text-white fs-5'>Connecting your profile allows us to fetch accurate campaign data so you can view performance and <br /> manage your ads inside the portal.</p>
            </div>

            <div
              className="row g-3 mb-4"
              style={{ maxHeight: '70vh', overflowY: 'auto' }}
            >
              {Array.isArray(authData) && authData.length > 0 ? (
                authData.map((account) => {
                  const isSelected = selectedAccounts.some(
                    (a) => a?.external_id === account?.external_id
                  );
                  const isAlreadySelected = account.selected === true;

                  return (
                    <div
                      key={account?.external_id}
                      className="col-12 col-sm-6 col-md-4 col-lg-3"
                    >
                      <div
                        className={`account-card card border-0 rounded-lg shadow-sm cursor-pointer transition-all position-relative 
                          ${isSelected ? 'border-primary shadow-lg' : 'hover-shadow'} 
                          ${isAlreadySelected ? 'bg-light text-muted' : ''}`}
                        onClick={() => !isAlreadySelected && toggleSelect(account)}
                        style={{
                          transition: 'transform 0.2s',
                          cursor: isAlreadySelected ? 'not-allowed' : 'pointer',
                          opacity: isAlreadySelected ? 0.6 : 1,
                        }}
                      >
                        <div className="card-body h-auto">
                          <h6 className="text-truncate account-type">{account?.account_type} Account</h6>
                          <h6 className="account-name text-truncate">{account.name}</h6>
                          <p className="card-text mb-1 d-flex flex-wrap">
                            <span className="me-2 account-id">{account?.external_id}</span>
                            <span className="text-muted account-id">({account.country})</span>
                          </p>

                          {isAlreadySelected && (
                            <p
                              className="mt-1 mb-0"
                              style={{
                                fontSize: '0.8rem',
                                color: 'green',
                                fontWeight: '500',
                              }}
                            >
                              Already connected
                            </p>
                          )}
                        </div>

                        {isSelected && !isAlreadySelected && (
                          <div
                            className="position-absolute top-0 end-0 m-2 bg-primary text-white rounded-circle"
                            style={{
                              width: '24px',
                              height: '24px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            ✓
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-12 text-center py-5">
                  <h2 className="mb-4">
                    No matching Ads Account found for the connected Seller Account.
                  </h2>
                  <a href="/marketplace-accounts" className="btn btn-primary px-4 py-2">Go to Marketplace Accounts</a>
                </div>
              )}
            </div>
            {selectedAccounts.length > 0 && <div className="sticky-bottom d-flex justify-content-center py-3">
              <button
                className="btn fw-bold bg-white"
                disabled={selectedAccounts.length === 0 || disableBtn}
                onClick={handleBulkConnect}
              >
                Connect Selected ({selectedAccounts.length})
              </button>
            </div>}
            <p className='text-white text-center fs-5'>If you work with more than one brand or region, choose the profile that matches the ad account you want to manage here.<br /> You can add or update profiles anytime.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmazoneAdsCartView;
